import React, { useState } from 'react';
import './Land.css';
import Nut from '../assets/Nutrition image.png';
import PdfViewer6 from '../About/PdfViewer6';
import Loader from '../Loader/Loader'; // import the Loader component

const Population = () => {
  const [showPdfViewer6, setShowPdfViewer6] = useState(false);
  const [loading, setLoading] = useState(false); // add state for loading indicator

  function handleReadMoreClick() {
    setLoading(true); // set loading state to true
    setTimeout(() => {
      setShowPdfViewer6(true);
      setLoading(false); // set loading state to false when the PDF viewer is ready
    }, 5000);
  }

  return (
    <div className="image-description">
      <img src={Nut} alt='asals' className="image" />
      <div className="description">
        <h2>Nutrition Levels: Stunting in children in ASALs and Non-ASALs
Counties in Kenya (2022)
</h2>
        {loading ? (
          <Loader /> // show the loading indicator
        ) : showPdfViewer6 ? (
          <PdfViewer6 onClose={() => setShowPdfViewer6(false)} />
        ) : (
          <>
            <p>Stunting is a form of chronic malnutrition that affects physical and cognitive development. It
is defined by low height-for-age, which can have long-term health, educational... </p>
            <button className="read-more-button" onClick={handleReadMoreClick}>Read More</button>
          </>
        )}
      </div>
    </div>
  );
};

export default Population;
